var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":_vm.id}},_vm._l((_vm.buttons),function(button,index){return _c('button-element',{key:index,attrs:{"id":button.id,"type":button.type,"text":button.text,"disabled":button.selected,"data":button,"border-style":_vm.getBorderStyle(index)},on:{"on-button-click":_vm.onClick}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }